module.exports = __webpack_public_path__ + "img/noOrder.dcb2fac2.png";